// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

body {
    margin: 0;
    background: #eee;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular',
        sans-serif;
    font-weight: 500;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.other h2 {
    font-size: 18px;
    color: #444;
    margin-bottom: 7px;
}

.other a {
    color: #777;
    text-decoration: underline;
    font-size: 14px;
}

.other ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
}

.App {
    font-family: sans-serif;
    text-align: center;
}

h1 {
    font-size: 24px;
    color: #333;
}

.ltr {
    text-align: left;
}

.rtl {
    text-align: right;
}

.editor-container {
    color: #000;
    position: relative;
    line-height: 20px;
    font-weight: 400;
    text-align: left;
    margin: 12px;
}

.editor-inner {
    position: relative;
    margin: 24px 0px 20px 0px;
}

.editor-input {
    resize: none;
    font-size: 15px;
    caret-color: rgb(5, 5, 5);
    position: relative;
    tab-size: 1;
    outline: 0;
    caret-color: #444;
    cursor: text;
}

.editor-placeholder {
    color: #999;
    overflow: hidden;
    position: absolute;
    text-overflow: ellipsis;
    top: 0px;
    /* left: 10px; */
    font-size: 15px;
    -webkit-user-select: none;
            user-select: none;
    display: inline-block;
    pointer-events: none;
}

.editor-text-bold {
    font-weight: bold;
}

.editor-text-italic {
    font-style: italic;
}

.editor-text-underline {
    text-decoration: underline;
}

.editor-text-strikethrough {
    text-decoration: line-through;
}

.editor-text-underlineStrikethrough {
    text-decoration: underline line-through;
}

.editor-text-code {
    background-color: rgb(240, 242, 245);
    padding: 1px 0.25rem;
    font-family: Menlo, Consolas, Monaco, monospace;
    font-size: 94%;
}

.editor-link {
    color: rgb(33, 111, 219);
    text-decoration: none;
}

.tree-view-output {
    display: block;
    background: #222;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    white-space: pre-wrap;
    margin: 1px auto 10px auto;
    max-height: 250px;
    position: relative;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow: auto;
    line-height: 14px;
}

.editor-code {
    background-color: rgb(240, 242, 245);
    font-family: Menlo, Consolas, Monaco, monospace;
    display: block;
    padding: 8px 8px 8px 52px;
    line-height: 1.53;
    font-size: 13px;
    margin: 0;
    margin-top: 8px;
    margin-bottom: 8px;
    tab-size: 2;
    /* white-space: pre; */
    overflow-x: auto;
    position: relative;
}

.editor-code:before {
    content: attr(data-gutter);
    position: absolute;
    background-color: #eee;
    left: 0;
    top: 0;
    border-right: 1px solid #ccc;
    padding: 8px;
    color: #777;
    white-space: pre-wrap;
    text-align: right;
    min-width: 25px;
}

.editor-code:after {
    content: attr(data-highlight-language);
    top: 0;
    right: 3px;
    padding: 3px;
    font-size: 10px;
    text-transform: uppercase;
    position: absolute;
    color: rgba(0, 0, 0, 0.5);
}

.editor-tokenComment {
    color: slategray;
}

.editor-tokenPunctuation {
    color: #999;
}

.editor-tokenProperty {
    color: #905;
}

.editor-tokenSelector {
    color: #690;
}

.editor-tokenOperator {
    color: #9a6e3a;
}

.editor-tokenAttr {
    color: #07a;
}

.editor-tokenVariable {
    color: #e90;
}

.editor-tokenFunction {
    color: #dd4a68;
}

.editor-paragraph {
    margin: 0;
    margin-bottom: 8px;
    position: relative;
}

.editor-paragraph:last-child {
    margin-bottom: 0;
}

.editor-heading-h1 {
    font-size: 24px;
    color: rgb(5, 5, 5);
    font-weight: 500;
    margin: 0;
    margin-bottom: 12px;
    padding: 0;
    line-height: normal;
}

.editor-heading-h2 {
    font-size: 18px;
    color: rgb(101, 103, 107);
    font-weight: 700;
    margin: 0;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 0;
    text-transform: uppercase;
    line-height: normal;
}

/* .PlaygroundEditorTheme__h1 {
    font-size: 24px;
    color: rgb(5, 5, 5);
    font-weight: 400;
    margin: 0;
  }
  .PlaygroundEditorTheme__h2 {
    font-size: 15px;
    color: rgb(101, 103, 107);
    font-weight: 700;
    margin: 0;
    text-transform: uppercase;
  } */
  .editor-heading-h3 {
    font-size: 14px;
    margin: 0;
    margin-bottom: 8px;
    text-transform: uppercase;
    line-height: normal;
  }

.editor-quote {
    margin: 0;
    margin-left: 20px;
    font-size: 15px;
    color: rgb(101, 103, 107);
    border-left-color: rgb(206, 208, 212);
    border-left-width: 4px;
    border-left-style: solid;
    padding-left: 16px;
}

.editor-list-ol {
    padding: 0;
    margin: 0;
    margin-left: 16px;
}

.editor-list-ul {
    padding: 0;
    margin: 0;
    margin-left: 16px;
}

.editor-listItemChecked,
.editor-listItemUnchecked {
    position: relative;
    margin-left: 8px;
    margin-right: 8px;
    padding-left: 24px;
    padding-right: 24px;
    list-style-type: none;
    outline: none;
}

.editor-listItemChecked {
    text-decoration: line-through;
}

.editor-listItemUnchecked:before,
.editor-listItemChecked:before {
    content: '';
    width: 16px;
    height: 16px;
    top: 2px;
    left: 0;
    cursor: pointer;
    display: block;
    background-size: cover;
    position: absolute;
}

.editor-listItemUnchecked[dir='rtl']:before,
.editor-listItemChecked[dir='rtl']:before {
    left: auto;
    right: 0;
}

.editor-listItemUnchecked:focus:before,
.editor-listItemChecked:focus:before {
    box-shadow: 0 0 0 2px #a6cdfe;
    border-radius: 2px;
}

.editor-listItemUnchecked:before {
    border: 1px solid #999;
    border-radius: 2px;
}

.editor-listItemChecked:before {
    border: 1px solid rgb(61, 135, 245);
    border-radius: 2px;
    background-color: #3d87f5;
    background-repeat: no-repeat;
}

.editor-listItemChecked:after {
    content: '';
    cursor: pointer;
    border-color: #fff;
    border-style: solid;
    position: absolute;
    display: block;
    top: 6px;
    width: 3px;
    left: 7px;
    right: 7px;
    height: 6px;
    transform: rotate(45deg);
    border-width: 0 2px 2px 0;
}

.editor-listitem {
    margin: 6px 0px 6px 14px;
}

.editor-nested-listitem {
    list-style-type: none;
}

pre::-webkit-scrollbar {
    background: transparent;
    width: 10px;
}

pre::-webkit-scrollbar-thumb {
    background: #999;
}


/* i.undo {
    background-image: url(icons/arrow-counterclockwise.svg);
  }
  
  i.redo {
    background-image: url(icons/arrow-clockwise.svg);
  }
  
  i.bold {
    background-image: url(icons/type-bold.svg);
  }
  
  i.italic {
    background-image: url(icons/type-italic.svg);
  }
  
  i.underline {
    background-image: url(icons/type-underline.svg);
  }
  
  i.strikethrough {
    background-image: url(icons/type-strikethrough.svg);
  }
  
  i.left-align {
    background-image: url(icons/text-left.svg);
  }
  
  i.center-align {
    background-image: url(icons/text-center.svg);
  }
  
  i.right-align {
    background-image: url(icons/text-right.svg);
  }
  
  i.justify-align {
    background-image: url(icons/justify.svg);
  } */`, "",{"version":3,"sources":["webpack://./src/components/flow/LexicalEditor.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;IACI,SAAS;IACT,gBAAgB;IAChB;kBACc;IACd,gBAAgB;IAChB,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;IACpB,+CAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;IAChC,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,+CAA+C;IAC/C,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;IACtB,OAAO;IACP,MAAM;IACN,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,MAAM;IACN,UAAU;IACV,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;KAYK;EACH;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;EACrB;;AAEF;IACI,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,qCAAqC;IACrC,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,OAAO;IACP,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,QAAQ;AACZ;;AAEA;;IAEI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,UAAU;IACV,SAAS;IACT,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAsCK","sourcesContent":["/**\n * Copyright (c) Meta Platforms, Inc. and affiliates.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE file in the root directory of this source tree.\n *\n */\n\nbody {\n    margin: 0;\n    background: #eee;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular',\n        sans-serif;\n    font-weight: 500;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.other h2 {\n    font-size: 18px;\n    color: #444;\n    margin-bottom: 7px;\n}\n\n.other a {\n    color: #777;\n    text-decoration: underline;\n    font-size: 14px;\n}\n\n.other ul {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n}\n\n.App {\n    font-family: sans-serif;\n    text-align: center;\n}\n\nh1 {\n    font-size: 24px;\n    color: #333;\n}\n\n.ltr {\n    text-align: left;\n}\n\n.rtl {\n    text-align: right;\n}\n\n.editor-container {\n    color: #000;\n    position: relative;\n    line-height: 20px;\n    font-weight: 400;\n    text-align: left;\n    margin: 12px;\n}\n\n.editor-inner {\n    position: relative;\n    margin: 24px 0px 20px 0px;\n}\n\n.editor-input {\n    resize: none;\n    font-size: 15px;\n    caret-color: rgb(5, 5, 5);\n    position: relative;\n    tab-size: 1;\n    outline: 0;\n    caret-color: #444;\n    cursor: text;\n}\n\n.editor-placeholder {\n    color: #999;\n    overflow: hidden;\n    position: absolute;\n    text-overflow: ellipsis;\n    top: 0px;\n    /* left: 10px; */\n    font-size: 15px;\n    user-select: none;\n    display: inline-block;\n    pointer-events: none;\n}\n\n.editor-text-bold {\n    font-weight: bold;\n}\n\n.editor-text-italic {\n    font-style: italic;\n}\n\n.editor-text-underline {\n    text-decoration: underline;\n}\n\n.editor-text-strikethrough {\n    text-decoration: line-through;\n}\n\n.editor-text-underlineStrikethrough {\n    text-decoration: underline line-through;\n}\n\n.editor-text-code {\n    background-color: rgb(240, 242, 245);\n    padding: 1px 0.25rem;\n    font-family: Menlo, Consolas, Monaco, monospace;\n    font-size: 94%;\n}\n\n.editor-link {\n    color: rgb(33, 111, 219);\n    text-decoration: none;\n}\n\n.tree-view-output {\n    display: block;\n    background: #222;\n    color: #fff;\n    padding: 5px;\n    font-size: 12px;\n    white-space: pre-wrap;\n    margin: 1px auto 10px auto;\n    max-height: 250px;\n    position: relative;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    overflow: auto;\n    line-height: 14px;\n}\n\n.editor-code {\n    background-color: rgb(240, 242, 245);\n    font-family: Menlo, Consolas, Monaco, monospace;\n    display: block;\n    padding: 8px 8px 8px 52px;\n    line-height: 1.53;\n    font-size: 13px;\n    margin: 0;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    tab-size: 2;\n    /* white-space: pre; */\n    overflow-x: auto;\n    position: relative;\n}\n\n.editor-code:before {\n    content: attr(data-gutter);\n    position: absolute;\n    background-color: #eee;\n    left: 0;\n    top: 0;\n    border-right: 1px solid #ccc;\n    padding: 8px;\n    color: #777;\n    white-space: pre-wrap;\n    text-align: right;\n    min-width: 25px;\n}\n\n.editor-code:after {\n    content: attr(data-highlight-language);\n    top: 0;\n    right: 3px;\n    padding: 3px;\n    font-size: 10px;\n    text-transform: uppercase;\n    position: absolute;\n    color: rgba(0, 0, 0, 0.5);\n}\n\n.editor-tokenComment {\n    color: slategray;\n}\n\n.editor-tokenPunctuation {\n    color: #999;\n}\n\n.editor-tokenProperty {\n    color: #905;\n}\n\n.editor-tokenSelector {\n    color: #690;\n}\n\n.editor-tokenOperator {\n    color: #9a6e3a;\n}\n\n.editor-tokenAttr {\n    color: #07a;\n}\n\n.editor-tokenVariable {\n    color: #e90;\n}\n\n.editor-tokenFunction {\n    color: #dd4a68;\n}\n\n.editor-paragraph {\n    margin: 0;\n    margin-bottom: 8px;\n    position: relative;\n}\n\n.editor-paragraph:last-child {\n    margin-bottom: 0;\n}\n\n.editor-heading-h1 {\n    font-size: 24px;\n    color: rgb(5, 5, 5);\n    font-weight: 500;\n    margin: 0;\n    margin-bottom: 12px;\n    padding: 0;\n    line-height: normal;\n}\n\n.editor-heading-h2 {\n    font-size: 18px;\n    color: rgb(101, 103, 107);\n    font-weight: 700;\n    margin: 0;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 0;\n    text-transform: uppercase;\n    line-height: normal;\n}\n\n/* .PlaygroundEditorTheme__h1 {\n    font-size: 24px;\n    color: rgb(5, 5, 5);\n    font-weight: 400;\n    margin: 0;\n  }\n  .PlaygroundEditorTheme__h2 {\n    font-size: 15px;\n    color: rgb(101, 103, 107);\n    font-weight: 700;\n    margin: 0;\n    text-transform: uppercase;\n  } */\n  .editor-heading-h3 {\n    font-size: 14px;\n    margin: 0;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    line-height: normal;\n  }\n\n.editor-quote {\n    margin: 0;\n    margin-left: 20px;\n    font-size: 15px;\n    color: rgb(101, 103, 107);\n    border-left-color: rgb(206, 208, 212);\n    border-left-width: 4px;\n    border-left-style: solid;\n    padding-left: 16px;\n}\n\n.editor-list-ol {\n    padding: 0;\n    margin: 0;\n    margin-left: 16px;\n}\n\n.editor-list-ul {\n    padding: 0;\n    margin: 0;\n    margin-left: 16px;\n}\n\n.editor-listItemChecked,\n.editor-listItemUnchecked {\n    position: relative;\n    margin-left: 8px;\n    margin-right: 8px;\n    padding-left: 24px;\n    padding-right: 24px;\n    list-style-type: none;\n    outline: none;\n}\n\n.editor-listItemChecked {\n    text-decoration: line-through;\n}\n\n.editor-listItemUnchecked:before,\n.editor-listItemChecked:before {\n    content: '';\n    width: 16px;\n    height: 16px;\n    top: 2px;\n    left: 0;\n    cursor: pointer;\n    display: block;\n    background-size: cover;\n    position: absolute;\n}\n\n.editor-listItemUnchecked[dir='rtl']:before,\n.editor-listItemChecked[dir='rtl']:before {\n    left: auto;\n    right: 0;\n}\n\n.editor-listItemUnchecked:focus:before,\n.editor-listItemChecked:focus:before {\n    box-shadow: 0 0 0 2px #a6cdfe;\n    border-radius: 2px;\n}\n\n.editor-listItemUnchecked:before {\n    border: 1px solid #999;\n    border-radius: 2px;\n}\n\n.editor-listItemChecked:before {\n    border: 1px solid rgb(61, 135, 245);\n    border-radius: 2px;\n    background-color: #3d87f5;\n    background-repeat: no-repeat;\n}\n\n.editor-listItemChecked:after {\n    content: '';\n    cursor: pointer;\n    border-color: #fff;\n    border-style: solid;\n    position: absolute;\n    display: block;\n    top: 6px;\n    width: 3px;\n    left: 7px;\n    right: 7px;\n    height: 6px;\n    transform: rotate(45deg);\n    border-width: 0 2px 2px 0;\n}\n\n.editor-listitem {\n    margin: 6px 0px 6px 14px;\n}\n\n.editor-nested-listitem {\n    list-style-type: none;\n}\n\npre::-webkit-scrollbar {\n    background: transparent;\n    width: 10px;\n}\n\npre::-webkit-scrollbar-thumb {\n    background: #999;\n}\n\n\n/* i.undo {\n    background-image: url(icons/arrow-counterclockwise.svg);\n  }\n  \n  i.redo {\n    background-image: url(icons/arrow-clockwise.svg);\n  }\n  \n  i.bold {\n    background-image: url(icons/type-bold.svg);\n  }\n  \n  i.italic {\n    background-image: url(icons/type-italic.svg);\n  }\n  \n  i.underline {\n    background-image: url(icons/type-underline.svg);\n  }\n  \n  i.strikethrough {\n    background-image: url(icons/type-strikethrough.svg);\n  }\n  \n  i.left-align {\n    background-image: url(icons/text-left.svg);\n  }\n  \n  i.center-align {\n    background-image: url(icons/text-center.svg);\n  }\n  \n  i.right-align {\n    background-image: url(icons/text-right.svg);\n  }\n  \n  i.justify-align {\n    background-image: url(icons/justify.svg);\n  } */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
